
































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import TransportDetail from '../../../store/entities/transportdetail'
import Transport from '../../../store/entities/transport'
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';

@Component
export default class ViewTransport extends mixins(DateTimeMixin, AbpBase){
    @Prop({type:Boolean,default:false}) value:boolean;
    transport:TransportDetail=new TransportDetail();
    title: string = '';
    cancel() {
        (this.$refs.viewTransportForm as any).resetFields();
        this.$store.state.transport.viewTransport = new Transport();
        this.$emit("input", false);
    }
    created(){}
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        } 
        else
        {
           const viewtransport =  Util.extend(true,{}, this.$store.state.transport.viewTransport);
            this.$store.dispatch({
                type:'transport/get',
                data: { id : viewtransport.id}
            }).then((result) => {
            this.transport = result;
            this.title = Util.L('ViewTransport')+"-"+this.transport.code;
            });
        }
    }
}
